import axios from 'axios';
import getHeaders from '../utils/getHeaders';
import { eventsSearchKeys, fuseSearch } from '@upshow/live-events';
import Fuse from 'fuse.js';

const BASE_URL = process.env.REACT_APP_REST_URL;

export const getMenuData = async (events) => {
    const { data } = await axios.get(`${BASE_URL}/v6/menu_data`, {
        headers: getHeaders(),
    });

    // Only include sports that have at least one event
    const sportsWithEvents = data.sports.filter((sport) => events.some((ev) => Array.isArray(ev.sports) && ev.sports.some((s) => String(s.id) === String(sport.id))));

    return {
        sports: sportsWithEvents,
        shortcuts: data.shortcuts.filter((shortcut) => {
            const searchResults = fuseSearch(Fuse, events, eventsSearchKeys, shortcut.searchTerm);
            return searchResults.length > 0;
        }),
    };
};
